import { qs } from '../dom-helpers';
import FormValidator from './class.FormValidator';
import AJAX from './class.AJAX';
import Abstract from './class.Abstract';

class ChangePassword {
  constructor() {
    if (!qs('form.account__form--change-password')) return;

    this.form = qs('form.account__form--change-password');
    this.formStatus = qs('form.account__form--change-password .alert', this.form);
    this.submitButton = qs('[type="submit"]', this.form);

    this._run();
  }

  _run() {
    this._handleSubmit();
  }

  _handleSubmit() {
    const _this = this;

    this.form.addEventListener('submit', (e) => {
      e.preventDefault();

      if (!this._isFormValid()) return;

      const data = new FormData(this.form);

      AJAX.post({
        action: 'mst_somi_change_password',
        data: Abstract.formDataToObject(data),
        beforeSend() {
          _this.submitButton.disabled = true;
        },
        complete() {
          _this.submitButton.disabled = false;
        },
        success(response) {
          _this._writeStatus(response.data.message);
        },
      });
    });
  }

  _isFormValid() {
    return new FormValidator().isValid(this.form, {
      old_password: {
        presence: true,
      },
      new_password: {
        presence: true,
      },
      password_confirmation: {
        presence: true,
      },
    });
  }

  _writeStatus(status) {
    this.formStatus.innerText = status;
  }
}

export default ChangePassword;
